export default __webpack_public_path__ + "static/media/IBMCaretUp.bea2c168.svg";